import Head from 'next/head';
import OffCanvas from '@/components/OffCanvas';

const Page = () => {
  return (
    <>
      <Head>
        <title>Offcanvas</title>
      </Head>

      <h1>Offcanvas</h1>
      <OffCanvas />
    </>
  );
};

export default Page;
